<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container main_bg">
      <i-card-vertical headerTitle="개선 요구 및 결과" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="searchYear"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            year
            full-width
            no-title
            @getDate="searchYearChanged"
          ></date-bar>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="improvementMeasuresManageGrid"
                  class="layout-col-height00"
                  style="width: 100%; height: 100%"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  key-expr="id"
                  @editing-start="onEditingStart"
                  @editor-preparing="onEditorPreparing"
                >
                  <DxColumn
                    data-field
                    data-type="string"
                    width="120px"
                    alignment="center"
                    caption
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="grid-btn rounded">상세보기</v-btn>
                    </div>
                  </template>
                  <DxColumn data-field="docNm" data-type="string" alignment="center" width="450px" caption="문서번호" :allow-editing="false" />
                  <DxColumn
                    data-field="requestStatusCd"
                    data-type="string"
                    alignment="center"
                    width="200px"
                    caption="결과 보고"
                    :allow-editing="false"
                    cell-template="requestList"
                  />
                  <template #requestList="{ data: cellInfo }">
                    <div :style="getStatusStyle('requestList', cellInfo.data.requestStatusCd)">
                      {{ getStatusNm('requestList', cellInfo.data.requestStatusCd) }}
                    </div>
                  </template>
                  <DxColumn
                    data-field
                    data-type="string"
                    alignment="center"
                    width="200px"
                    caption="조치 확인"
                    :allow-editing="false"
                    cell-template="resultStatus"
                  />
                  <template #resultStatus="{ data: cellInfo }">
                    <div :style="getStatusStyle('resultList', cellInfo.data.resultStatusCd)">
                      {{ getStatusNm('resultList', cellInfo.data.resultStatusCd) }}
                    </div>
                  </template>
                  <DxColumn
                    data-field="writeDt"
                    data-type="date"
                    format="yyyy.MM.dd"
                    alignment="center"
                    width="200px"
                    caption="작성일"
                    :allow-editing="false"
                  />
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap" :class="{ 'guide-highlight-add': guideHighlightAdd }">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnAdd="btnAdd" @btnDelete="btnDelete"></i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import { getPreMonth, getYearFormat } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import dateBar from '@/components/common/dateBar.vue'
// UTILS
import { getCurrentDate } from '@/utils/common.js'

// API
import { getCommonCode } from '@/api/common/commonApi'
import { getImprovementMeasuresList, deleteImprovementMeasures } from '@/api/evaluationImprovement/improvementMeasuresManage.js'
export default {
  mixins: [baseview, BaseDataGrid],
  name: 'ImprovementMeasuresManage',
  components: {
    'date-bar': dateBar,
  },
  data() {
    return {
      initCompId: '',
      dxDataGridRef: 'improvementMeasuresManageGrid',
      buttonUseList: [
        'btnSearch', // 조회
        'btnAdd', // 추가
        'btnDelete', // 삭제
      ],
      gridMain: [],
      searchYear: getYearFormat(getPreMonth(0)),
      requestList: [], // 결과 보고 상태값
      resultList: [], // 조치 확인 상태값
      guideHighlightAdd: false, // 반기평가 이동 시 추가하기 버튼 깜빡임
      _guideHighlightTimer: null,
    }
  },
  computed: {},
  watch: {
    // 반기 이행평가에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        console.log('@@ $route.query._t', val, oldVal)
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  created() {
    // 결과 보고 상태값 코드 조회
    getCommonCode('SE002').then((res) => {
      this.requestList = res.list
    })
    // 조치 확인 상태값 코드 조회
    getCommonCode('SE003').then((res) => {
      this.resultList = res.list
    })
  },
  beforeMount() {},
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    if (this.$route.params) {
      if (this.$route.params.search) this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch()
    }
  },
  mounted() {
    this.initCompId = this.getCompId()
    this.btnSearch(true)
    this.applyGuideHighlightFromRoute()
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  methods: {
    // 반기 이행평가에서 진입 시 추가하기 버튼을 붉게 깜빡여 안내
    applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (routeData.searchYear) {
        this.searchYear = String(routeData.searchYear)
      }

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightAdd = false
      this.$nextTick(() => {
        this.guideHighlightAdd = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightAdd = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    getStatusStyle(dataList, status) {
      // 진행상태에 따라 스타일 부여
      let style = 'color:#B4B4B4;'
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) {
        switch (statusCd.minorCd) {
          case 'N':
            style = `color:#B4B4B4;`
            break
          case 'R':
            style = `color:#FF2D2D;`
            break
          case 'A':
            style = `color:#1B53F3;`
            break
        }
      }
      return style
    },
    getStatusNm(dataList, status) {
      let statusCd = this[dataList].find((el) => el.minorCd === status)
      if (statusCd) return statusCd.minorNm
      else return '-'
    },
    /*************************************************************************************************/
    /* 버튼 이벤트 */
    /*************************************************************************************************/
    async btnSearch(isNotify) {
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        searchYear: this.searchYear.substring(0, 4),
      }
      this.openLoading()
      getImprovementMeasuresList(params, isNotify)
        .then((res) => {
          if (res.success) {
            this.gridMain = res.list
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true,
      })
      // 추가되는 항목의 문서번호 채번
      let filteredData = this.gridMain.filter((el) => el.writeDt === getCurrentDate().replaceAll('-', ''))
      let maxDocNo = filteredData.length > 0 ? Math.max(...filteredData.map((obj) => obj.docNo)) : 0
      let docNo = (maxDocNo + 1).toString().padStart(5, '0')
      data.docNm = `${this.getClntId()}-${this.getCompId()}-${getCurrentDate().replaceAll('-', '')}-${docNo}`
      const toRouter = {
        name: 'ImprovementMeasuresManageDetail',
        params: {
          data: data,
        },
      }
      this.$router.push(toRouter)
    },
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        //yes action
        (current) => {
          this.openLoading()
          selectedRows[0].subMenu = 'request'
          deleteImprovementMeasures(selectedRows, true)
            .then((res) => {
              this.btnSearch()
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        }
      )
    },
    async btnDetail(cellInfo) {
      console.log('### cellInfo', cellInfo.data)
      if (cellInfo.data.resultReviewDiv) {
        cellInfo.data.resultReviewDivIdx = this.resultList.findIndex((el) => el.minorCd === cellInfo.data.resultReviewDiv)
      }
      const toRouter = {
        name: 'ImprovementMeasuresManageDetail',
        params: {
          data: cellInfo.data,
          // data: {
          //   clntId: cellInfo.data.clntId,
          //   compId: cellInfo.data.compId,
          //   writeDt: cellInfo.data.writeDt,
          //   docNo: cellInfo.data.docNo,
          //   __created__: cellInfo.data.__created__
          // }
        },
      }
      this.$router.push(toRouter)
    },

    /*************************************************************************************************/
    /* 기타 이벤트 */
    /*************************************************************************************************/
    searchYearChanged(year) {
      this.searchYear = String(year)
      this.btnSearch()
    },
  },
}
</script>
  
<style lang="scss">
@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-add .btn_btnAdd {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
  